import React, { Fragment, useState, useEffect, useContext } from "react";
import "./sectionSpecialist.scss";
import CardSpecialist from "../../atoms/card-specialist/cardSpecialist";
import ArrowButton from "../../atoms/arrow-button/arrowButton";
import SeccionTitle from "../../atoms/seccion-title/seccionTitle";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getAllResources } from "../../../services/scheduling";
import Loading from "../../atoms/loading/loading";
import SearcherSchedule from "../../molecules/searcher-schedule/searcher-schedule";
import GlobalContext from "../../../contexts/globalContext";
import BreadcrumbScheduling from "../../atoms/breadcrumb-scheduling/breadcrumb-scheduling";

interface SectionSpecialistInterface {
  setnextPage: any;
  setpageAtive: any;
  nameCategory: string;
  selectCategory: any;
  setselectSpecialist: any;
  content: any;
  afterPage: string;
  beforePage: string;
}

const SectionSpecialist = (props: SectionSpecialistInterface) => {
  const {
    content,
    afterPage,
    beforePage,
    setnextPage,
    setpageAtive,
    selectCategory,
    setselectSpecialist,
  } = props;
  const [cardActvie, setcardActvie] = useState("");
  const [allSpecialist, setallSpecialist] = useState<any>([]);
  const [selectSpecialitsSearch, setselectSpecialitsSearch] = useState<any>("");
  const [numberSeemore, setnumberSeemore] = useState<any>(4);
  const [loading, setloading] = useState(false);
  const contextValue = useContext(GlobalContext);
  const settings = {
    arrows: false,
    dots: true,
    infinite: false,
    rows: 2,
    speed: 500,
    slidesToShow: 2.7,
    slidesToScroll: 2,
  };

  useEffect(() => {
    setnextPage("Fecha y Hora");
    getSpecialist();
  }, []);

  const getSpecialist = async () => {
    try {
      setloading(true);
      const specialist = await getAllResources(
        contextValue.userInfoContext.data?.userJwt,
        selectCategory.resourcesIds,
        selectCategory.id
      );
      setallSpecialist(specialist.data.data.body.data);
      setloading(false);
    } catch (error) {
      setloading(false);
    }
  };

  const shortSpecialist = () => {
    let specialistArray: any = [];
    if (allSpecialist.length > 12) {
      for (let i = 0; i < 12; i++) {
        specialistArray.push(allSpecialist[i]);
      }
      return specialistArray;
    } else {
      return allSpecialist;
    }
  };

  const seeMore = () => {
    let arrayListM: any = [];
    if (allSpecialist.length > numberSeemore) {
      for (
        let i = 0;
        i <
        (numberSeemore > allSpecialist.length
          ? allSpecialist.length
          : numberSeemore);
        i++
      ) {
        arrayListM.push(allSpecialist[i]);
      }
      return arrayListM;
    } else {
      return allSpecialist;
    }
  };

  return (
    <>
      <div className="o-spectiali-breadcrumb">
        <BreadcrumbScheduling
          content={`Agendamiento / ${selectCategory.name} / Profesional`}
        />
        <div className="o-specialist">
          <div className="o-specialist__content__left">
            <SeccionTitle
              title={content.tituloBanner}
              description={content.tituloDescripcion}
            />
            <SearcherSchedule
              type="comfama"
              defaultPlaceholder={"Buscar profesionales"}
              allSpecialist={allSpecialist}
              setselectSpecialitsSearch={setselectSpecialitsSearch}
              selectSpecialitsSearch={selectSpecialitsSearch}
              setcardActvie={setcardActvie}
            />
          </div>
          <div className="o-specialist__content__right">
            {loading && <Loading />}
            {selectSpecialitsSearch.length > 0 ? (
              <div className="hide-on-mobile">
                <CardSpecialist
                  specialist={allSpecialist.find(
                    (el) => el.id === selectSpecialitsSearch
                  )}
                  description={selectCategory.description}
                  active={true}
                  setcardActvie={setcardActvie}
                  selectSpecialitsSearch={selectSpecialitsSearch}
                  setselectSpecialitsSearch={setselectSpecialitsSearch}
                  gtm={`${selectCategory.name}`}
                />
              </div>
            ) : (
              <Slider {...settings} className="hide-on-mobile">
                {allSpecialist &&
                  shortSpecialist().map((specialist, index) => (
                    <Fragment key={`specialist-${index}`}>
                      <CardSpecialist
                        specialist={specialist}
                        active={cardActvie === specialist.id}
                        description={selectCategory.description}
                        setcardActvie={setcardActvie}
                        selectSpecialitsSearch={selectSpecialitsSearch}
                        setselectSpecialitsSearch={setselectSpecialitsSearch}
                        gtm={`${selectCategory.name}`}
                      />
                    </Fragment>
                  ))}
              </Slider>
            )}
            {selectSpecialitsSearch.length > 0 ? (
              <div className="show-on-mobile">
                <CardSpecialist
                  specialist={allSpecialist.find(
                    (el) => el.id === selectSpecialitsSearch
                  )}
                  active={true}
                  setcardActvie={setcardActvie}
                  description={selectCategory.description}
                  selectSpecialitsSearch={selectSpecialitsSearch}
                  setselectSpecialitsSearch={setselectSpecialitsSearch}
                  gtm={`${selectCategory.name}`}
                />
              </div>
            ) : (
              <div className="show-on-mobile">
                {allSpecialist &&
                  numberSeemore &&
                  seeMore().map((specialist, index) => (
                    <Fragment key={`specialist-${index}`}>
                      <CardSpecialist
                        specialist={specialist}
                        active={cardActvie === specialist.id}
                        setcardActvie={setcardActvie}
                        description={selectCategory.description}
                        selectSpecialitsSearch={selectSpecialitsSearch}
                        setselectSpecialitsSearch={setselectSpecialitsSearch}
                        gtm={`${selectCategory.name}`}
                      />
                    </Fragment>
                  ))}
              </div>
            )}
            {allSpecialist.length >= numberSeemore && (
              <div className="show-on-mobile">
                <div className="o-specialist__content__right__seemore">
                  <div onClick={() => setnumberSeemore(numberSeemore * 2)}>
                    <p>Ver más</p>
                    <i className="icon icon-arrow-down" />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="o-specialist__footer">
          <ArrowButton
            text={beforePage}
            way={"left"}
            gtmMark={
              "gtmRedDeAmorSesionIniciadaAgendarServicioCategoriaAnteriorCategorias"
            }
            onAction={() => {
              setnextPage("Profesional");
              setpageAtive(1);
            }}
          />
          <ArrowButton
            text={afterPage}
            way={"right"}
            gtmMark={
              "gtmRedDeAmorSesionIniciadaAgendarServicioCategoriaSiguienteHorario"
            }
            onAction={() => {
              if (cardActvie) {
                const specialistSelect = allSpecialist.find(
                  (el) => el.id === cardActvie
                );
                setselectSpecialist(specialistSelect);
                setpageAtive(3);
              }
            }}
          />
        </div>
      </div>
    </>
  );
};

export default SectionSpecialist;
